import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { getProductTagCodes } from "./getProductTagCodes"

const PARTNER_TAG_PREFIX = "partner."

const graphQLFragments = {
    product: graphql(
        `
            fragment getProductPartnerName_Product on Product {
                ...getProductTagCodes_Product
            }
        `,
        [getProductTagCodes.fragments.product]
    ),
}

// Partner offers carry a `partner.<partnername>` product tag.
export function getProductPartnerName(fragment: FragmentOf<typeof graphQLFragments.product>) {
    const product = readFragment(graphQLFragments.product, fragment)

    const partnerTagCode = getProductTagCodes(product).find(
        (code) => code && code.startsWith(PARTNER_TAG_PREFIX)
    )

    const partnerName = partnerTagCode?.slice(PARTNER_TAG_PREFIX.length)

    if (!partnerName) return undefined

    return partnerName.charAt(0).toUpperCase() + partnerName.slice(1)
}

getProductPartnerName.fragments = graphQLFragments
